import React from 'react';
import './partnerCard.css'
const PartnerCard = ({ partnerInfo }) => {
    return (
        <div className="col-md-6 ">
            <a target="_blank" className="text-decoration-none"href={partnerInfo?.link[0]?.text}>
                <div className="partner-card">
                    <div className="pt-md-2  partner-media ">
                        <img src={partnerInfo?.icon?.url} alt="" className="img-fluid" />
                    </div>
                    <p className="p-0 m-0 w-75 pb-3">{partnerInfo?.title1}</p>
                </div>
            </a>
        </div>
    );
};

export default PartnerCard;